// removed by extract-text-webpack-plugin
module.exports = {"ticketingCcModalWrapper":"ticketing-cc-modal-wrapper--1-M2d","deleteIcon":"delete-icon--2HnBQ","emailText":"email-text--xs_Bp","confirmBtnWrapper":"confirm-btn-wrapper--1vAa8","confirmBtn":"confirm-btn--1mnyg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/commons/ticketingCcModal/ticketingCcModal.scss
// module id = CzsT
// module chunks = 1